import swal from "sweetalert";

let signedOutElsewhere = false;

/**
 * Clear the local session and send the browser to login.
 * Used when a bearer token is rejected because the same account signed in elsewhere.
 */
export function logoutSignedInElsewhere(history) {
  if (signedOutElsewhere) {
    return;
  }
  signedOutElsewhere = true;

  try {
    localStorage.clear();
  } catch (e) {
    // Storage can throw in private mode; still leave the current screen.
  }

  const goToLogin = () => {
    if (history && typeof history.push === "function") {
      history.push("/login");
      return;
    }
    window.location.assign("/login");
  };

  swal(
    "",
    "You were logged out because this account signed in elsewhere.",
    "info"
  ).then(() => {
    goToLogin();
    signedOutElsewhere = false;
  });
}
